'use client'

export default function QuoteButton({ 
  content, 
  authorName, 
  authorId 
}: { 
  content: string, 
  authorName: string, 
  authorId: string 
}) {
  const handleQuote = () => {
    // Format structured HTML string for legacy/markdown transition compatibility
    const formattedQuote = `<blockquote><strong>${authorName} : </strong> ${content}</blockquote><p><br></p>`

    const event = new CustomEvent('add-quote', {
      detail: { 
        content: formattedQuote, 
        authorName, // <-- Passed successfully to the reply form event listener
        authorId 
      }
    })
    window.dispatchEvent(event)

    document.getElementById('reply-form')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <button 
      type="button"
      onClick={handleQuote}
      className="flex items-center gap-1 text-xs font-medium text-slate-400 hover:text-indigo-400 transition-colors ml-4 font-mono"
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
      Quote
    </button>
  )
}